const brandImageManifest = {
  Fuel_Shoes: [
    "8_-_2024-12-05T165622.978.jpg",
    "8_12_c7e8a479-7021-41d8-89b0-928541bff350.jpg",
    "Screenshot 2026-02-25 201652.png",
    "Screenshot 2026-02-25 202022.png",
    "WhatsApp Image 2026-02-24 at 11.13.32 AM.jpeg",
    "WhatsApp Image 2026-02-24 at 11.13.45 AM.jpeg",
  ],
  Delta_Plus_Shoes: [
    "71QkL6G3VoL.jpg",
    "delta-plus-jet3-s1p-anti-static-safety-shoes.jpg",
    "delta-plus-phoenix-s3-safety-boots-front.jpg",
    "delta-plus-saga-s3-brown-safety-boots(1).jpg",
    "DMEU_Y2340724_11_std.lang.all.jpg",
  ],
  Bata_shoes: [
    "14436055BLACK.jpg",
    "71HYBOnOeRL._AC_.jpg",
    "Bata-PU-SD-Zappy-Derby-Safety-Shoes.jpg",
    "IMG_8123.png",
    "PWR-310_311.png",
  ],
  Polo_shoes: [
    "41rjlFj5KIL._AC_.jpg",
    "indcare-polo-pvc-industrial-safety-shoes-818.jpg",
    "polo-safety-shoes-tan-color-1000x1000.jpg",
    "safety-shoes-make-7satr-polo-1000x1000.jpg",
    "WhatsApp Image 2026-02-24 at 11.13.33 AM.jpeg",
  ],
  Utex_Helmets: [
    "16834-106_image_0.jpg",
    "16834-127_image_0.jpg",
    "IMG-20251203-WA0002.jpg",
  ],
  Ultra_KK_Industries: [
    "414QzFhBtXL.jpg",
    "61xKJune7mL.jpg",
    "Industrial-fire-extinguishers-Made-with-PosterMyWall.jpg",
  ],
  balaji_Fire_Safety: [
    "Screenshot 2026-02-25 210859.png",
    "Screenshot 2026-02-25 210943.png",
    "Screenshot 2026-02-25 210959.png",
    "Screenshot 2026-02-25 211016.png",
    "Screenshot 2026-02-25 211053.png",
    "Screenshot 2026-02-25 211134.png",
    "Screenshot 2026-02-25 211154.png",
    "Screenshot 2026-02-25 211257.png",
  ],
};

export default brandImageManifest;
